// Display metadata only. A saved highlight never downloads or pins clip audio.
const key = uid => `saved-highlight-metadata.${uid}`;
const metadataOnly = record => {
    const { transcript, transcripts, messages, trackMp3URL, ...preview } = record.preview || {};
    return { ...record, preview };
};
export const readSavedPreviewCache = uid => {
    try {
        const pages = uid ? JSON.parse(localStorage.getItem(key(uid)) || '{}') : {};
        if (!pages || typeof pages !== 'object') return {};
        return Object.fromEntries(Object.entries(pages).filter(([, page]) => Array.isArray(page?.records))
            .map(([filter, page]) => [filter, { ...page, records: page.records.filter(record =>
                typeof record?.preview?.id === 'string' && typeof record.savedAt === 'string' && Array.isArray(record.savedListIds)) }]));
    }
    catch (_) { return {}; }
};
export const writeSavedPreviewCache = (uid, pages) => {
    if (!uid) return;
    const bounded = Object.fromEntries(Object.entries(pages).map(([filter, page]) => {
        const records = page.records.slice(0, 100).map(metadataOnly);
        const last = records[records.length - 1];
        return [filter, { records, nextCursor: page.records.length > 100
            ? { savedAt: last.savedAt, previewId: last.preview.id } : page.nextCursor || null }];
    }));
    try { localStorage.setItem(key(uid), JSON.stringify(bounded)); } catch (_) { /* Storage may be unavailable. */ }
};
// Use the server's lexical cursor order, independent of the browser locale.
export const sortSavedPreviews = records => records.sort((a, b) => {
    if (a.savedAt !== b.savedAt) return a.savedAt < b.savedAt ? 1 : -1;
    return a.preview.id === b.preview.id ? 0 : a.preview.id < b.preview.id ? 1 : -1;
});
export const updateSavedPreviewPages = (pages, previewId, saved) => {
    const existing = saved && !pages.__all__ ? { ...pages, __all__: { records: [], nextCursor: null } } : pages;
    return Object.fromEntries(Object.entries(existing).map(([filter, page]) => {
        const records = page.records.filter(record => record.preview.id !== previewId);
        if (saved && (filter === '__all__' || saved.savedListIds.includes(filter))) records.push(saved);
        return [filter, { ...page, records: sortSavedPreviews(records) }];
    }));
};
export const safeSavedEpisodeStart = record => {
    const offset = record.preview?.fullTrackStartTimeSecs;
    const duration = record.preview?.fullTrackTotalTimeSecs;
    return typeof offset === 'number' && Number.isFinite(offset) && offset >= 0
        && typeof duration === 'number' && Number.isFinite(duration) && offset < duration ? offset : null;
};
